import React from 'react';

export function OpenLink() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
           <path d="M18.5455 16.3637V18.0001C18.5455 19.1046 17.65 20.0001 16.5455 20.0001H6C4.89543 20.0001 4 19.1046 4 18.0001V7.45459C4 6.35002 4.89543 5.45459 6 5.45459H7.63637" />
           <path d="M12.2464 3.85698H19.9603M19.9603 3.85698V11.5709M19.9603 3.85698L11 13" />
        </svg>
    );
}
